/* Duskhaven recently viewed ("Still deciding?"), 2026-10-03 (Duskhaven 2.0, phase 2).
 * <dh-recent> is rendered by sections/dh-recent.liquid (a rail of dh cards) and by snippets/cart-drawer.liquid
 * (data-variant="drawer": a compact row in the empty cart drawer). Product pages record each visit in localStorage
 * ("dh-recent", the last 8 product handles, newest first; written by the inline script in sections/dh-recent.liquid).
 * When the element comes near the screen it fetches each piece from /products/<handle>.js (kept for 10 minutes in
 * sessionStorage), leaves out data-exclude (the product on screen) and draws the cards. Handles that no longer
 * exist (404) are dropped from the list. The gold symbol comes from assets/dh-symbols.js, which decorates any
 * .dh-ux-cart-pick__name element holding a Duskhaven name. With nothing to show the element stays empty.
 * Storage access is wrapped in try/catch (private windows, blocked storage). No import() in this classic asset.
 * 2026-10-08 (Todd): the section cards now have the same image arrows and quick view (eye) button as the other product
 * cards. They use the same markup as snippets/dh-product-card.liquid (gallery mode), so assets/dh-card-gallery.js
 * (loaded by sections/dh-recent.liquid) handles the arrows, the hover image and the quick view. The cache key is v2
 * because cached entries now carry the product's photos.
 * 2026-10-14 (Todd, Duskhaven 4.6): the name's first letter is wrapped in .dh-card-initial, as in snippets/dh-product-card.liquid,
 * so these cards match the homepage Featured Items cards (bigger first letter; sizing and symbol in assets/dh-calm.css). */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('dh-recent')) return;

  var KEY = 'dh-recent';
  var CACHE = 'dh-recent-cache-v2';
  var TTL = 10 * 60 * 1000;
  var MAX = 8;
  var MAX_PHOTOS = 10;

  var ICON_PREV = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="m15 6-6 6 6 6"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="m9 6 6 6-6 6"/></svg>';
  var ICON_EYE = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0"/><path d="M21 12q-3.6 6-9 6t-9-6q3.6-6 9-6t9 6"/></g></svg>';

  function readList() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) return [];
      return list.filter(function (h) { return typeof h === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(h); }).slice(0, MAX);
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      if (list.length) localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
      else localStorage.removeItem(KEY);
    } catch (e) {}
  }

  function readCache() {
    try { return JSON.parse(sessionStorage.getItem(CACHE) || '{}') || {}; } catch (e) { return {}; }
  }

  function writeCache(cache) {
    try { sessionStorage.setItem(CACHE, JSON.stringify(cache)); } catch (e) {}
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function stripQuery(src) { return String(src || '').split('?')[0].replace(/^https?:/, ''); }

  // The card's photos: the featured image first, then the others. The name-and-symbol photo is left out, as on the other
  // cards (found by alt text or file name).
  function photos(p) {
    var skip = {};
    (p.media || []).forEach(function (m) {
      if (m && m.media_type === 'image' && /name[-_ ]?symbol|name[-_ ]?photo|name and symbol/i.test(String(m.src || '') + ' ' + String(m.alt || ''))) skip[stripQuery(m.src)] = true;
    });
    var first = p.featured_image || (p.images && p.images[0]) || '';
    var list = first ? [first] : [];
    (p.images || []).forEach(function (src) {
      if (!src || skip[stripQuery(src)] || stripQuery(src) === stripQuery(first)) return;
      if (/name[-_ ]?symbol|name[-_ ]?photo/i.test(String(src))) return;
      list.push(src);
    });
    return list.slice(0, MAX_PHOTOS);
  }

  function slim(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var w = 0, h = 0;
    (p.media || []).some(function (m) {
      if (m && m.media_type === 'image' && m.width && m.height) { w = m.width; h = m.height; return true; }
      return false;
    });
    return {
      handle: p.handle,
      title: p.title || '',
      url: p.url || (root() + 'products/' + p.handle),
      price: p.price,
      varies: !!p.price_varies,
      available: p.available !== false,
      image: img,
      images: photos(p),
      w: w,
      h: h
    };
  }

  var inflight = {};
  function load(handle) {
    var cache = readCache();
    var hit = cache[handle];
    if (hit && Date.now() - hit.t < TTL) return Promise.resolve(hit.p);
    if (inflight[handle]) return inflight[handle];
    inflight[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (response.status === 404) return null;
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (product) {
        var value = product && product.handle ? slim(product) : null;
        var next = readCache();
        next[handle] = { t: Date.now(), p: value };
        writeCache(next);
        delete inflight[handle];
        return value;
      }, function (error) {
        delete inflight[handle];
        throw error;
      });
    return inflight[handle];
  }

  // "Name - Short description", as in snippets/dh-product-card.liquid: the name is at most three words.
  function splitTitle(title) {
    var match = /^(.+?)\s[–—-]\s(.+)$/.exec(String(title || ''));
    if (match && match[1].trim().split(/\s+/).length <= 3) return { name: match[1].trim(), desc: match[2].trim() };
    return { name: '', desc: String(title || '') };
  }

  function imageUrl(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function formatMoney(cents, format, shopCurrency) {
    var value = (Number(cents) || 0) / 100;
    var active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (active && shopCurrency && active !== shopCurrency) {
      try {
        var whole = Math.round(value * 100) % 100 === 0;
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency: active, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
        }).format(value);
      } catch (e) {}
    }
    var pattern = format || '${{amount}}';
    function fmt(decimals, thousands, decimal) {
      var parts = value.toFixed(decimals).split('.');
      var head = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? head + decimal + parts[1] : head;
    }
    var key = (/\{\{\s*(\w+)\s*\}\}/.exec(pattern) || [])[1] || 'amount';
    var amount;
    switch (key) {
      case 'amount_no_decimals': amount = fmt(0, ',', '.'); break;
      case 'amount_with_comma_separator': amount = fmt(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': amount = fmt(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': amount = fmt(2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': amount = fmt(0, ' ', '.'); break;
      case 'amount_with_space_separator': amount = fmt(2, ' ', ','); break;
      default: amount = fmt(2, ',', '.');
    }
    amount = amount.replace(/[.,]00$/, ''); // like money_without_trailing_zeros
    return pattern.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function picture(p, sizes, widths) {
    var img = document.createElement('img');
    img.src = imageUrl(p.image, widths[widths.length - 1]);
    img.srcset = widths.map(function (w) { return imageUrl(p.image, w) + ' ' + w + 'w'; }).join(', ');
    img.sizes = sizes;
    img.alt = p.title;
    img.loading = 'lazy';
    img.decoding = 'async';
    if (p.w && p.h) { img.width = p.w; img.height = p.h; }
    return img;
  }

  class DhRecent extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;
      this.body = this.querySelector('[data-dh-recent-body]');
      this.list = this.querySelector('[data-dh-recent-list]');
      if (!this.body || !this.list) return;
      var clear = this.querySelector('[data-dh-recent-clear]');
      if (clear) {
        clear.addEventListener('click', function () {
          writeList([]);
          this.body.hidden = true;
          this.list.textContent = '';
        }.bind(this));
      }
      var handles = this.handles();
      if (!handles.length) return;
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) {
            this._io.disconnect();
            this.render();
          }
        }.bind(this), { rootMargin: '600px 0px' });
        this._io.observe(this);
      } else {
        this.render();
      }
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      this._started = false;
    }

    handles() {
      var exclude = (this.dataset.exclude || '').trim();
      var limit = parseInt(this.dataset.limit, 10) || MAX;
      return readList().filter(function (h) { return h !== exclude; }).slice(0, limit);
    }

    render() {
      var self = this;
      var handles = this.handles();
      if (!handles.length) return;
      Promise.all(handles.map(function (h) {
        return load(h).then(function (p) { return { h: h, p: p }; }, function () { return { h: h, p: undefined }; });
      })).then(function (results) {
        var gone = results.filter(function (r) { return r.p === null; }).map(function (r) { return r.h; });
        if (gone.length) writeList(readList().filter(function (h) { return gone.indexOf(h) === -1; }));
        var products = results.map(function (r) { return r.p; }).filter(Boolean);
        if (!products.length || !self.isConnected) return;
        self.list.textContent = '';
        var drawer = self.dataset.variant === 'drawer';
        products.forEach(function (p) { self.list.appendChild(drawer ? self.mini(p) : self.card(p)); });
        self.body.hidden = false;
        if (!drawer && !(window.Shopify && window.Shopify.designMode)) {
          // dh-refresh.js binds rail arrows inside the element this event is dispatched on;
          // dh-card-gallery.js binds the card photo arrows and the quick view button the same way.
          self.body.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
        }
      });
    }

    price(p) {
      var text = formatMoney(p.price, this.dataset.moneyFormat, this.dataset.currency);
      return { from: p.varies, text: text };
    }

    // Same markup as snippets/dh-product-card.liquid with gallery: true. Only the first photo is in the page;
    // the rest wait in a <template> until dh-card-gallery.js wakes the card (hover, focus, touch or an arrow press).
    media(p, parts) {
      var photosList = (p.images && p.images.length ? p.images : (p.image ? [p.image] : []));
      var restCount = Math.max(0, photosList.length - 1);
      var wrap = el('div', 'dh-card-media');
      wrap.setAttribute('data-dh-card-media', '');
      if (restCount > 0) wrap.setAttribute('data-dh-rest', String(restCount));

      var link = el('a', 'dh-card-image');
      link.href = p.url;
      link.setAttribute('aria-label', 'View ' + p.title);
      if (p.image) {
        var first = picture(p, '(max-width: 767px) 72vw, (max-width: 1100px) 30vw, 22vw', [360, 540, 720]);
        first.className = 'dh-card-slide is-active';
        link.appendChild(first);
      }
      wrap.appendChild(link);

      if (restCount > 0) {
        var tpl = document.createElement('template');
        tpl.setAttribute('data-dh-card-rest', '');
        photosList.slice(1).forEach(function (src, i) {
          var img = document.createElement('img');
          img.className = 'dh-card-slide';
          img.alt = p.title;
          if (i === 0) { img.src = imageUrl(src, 720); img.loading = 'lazy'; }
          else img.setAttribute('data-dh-src', imageUrl(src, 720));
          if (p.w && p.h) { img.width = p.w; img.height = p.h; }
          tpl.content.appendChild(img);
        });
        wrap.appendChild(tpl);
      }

      if (!p.available) {
        var badges = el('div', 'dh-card-badges');
        badges.appendChild(el('span', 'dh-card-badge', 'Sold out'));
        wrap.appendChild(badges);
      }

      var controls = el('div', 'dh-card-controls');
      if (restCount > 0) {
        var arrows = el('div', 'dh-card-arrows');
        var prev = el('button', 'dh-card-btn');
        prev.type = 'button';
        prev.setAttribute('data-dh-card-prev', '');
        prev.setAttribute('aria-label', 'Previous image of ' + p.title);
        prev.innerHTML = ICON_PREV;
        var next = el('button', 'dh-card-btn');
        next.type = 'button';
        next.setAttribute('data-dh-card-next', '');
        next.setAttribute('aria-label', 'Next image of ' + p.title);
        next.innerHTML = ICON_NEXT;
        arrows.appendChild(prev);
        arrows.appendChild(next);
        controls.appendChild(arrows);
      }
      var quick = el('button', 'dh-card-btn dh-card-quick');
      quick.type = 'button';
      quick.setAttribute('data-dh-quick-view', p.url);
      quick.setAttribute('aria-haspopup', 'dialog');
      quick.setAttribute('aria-label', 'Quick view: ' + p.title);
      quick.title = 'Quick view';
      quick.innerHTML = ICON_EYE;
      controls.appendChild(quick);
      wrap.appendChild(controls);
      return wrap;
    }

    card(p) {
      var parts = splitTitle(p.title);
      var article = el('article', 'dh-card dh-card--gallery dh-recent-card' + (p.available ? '' : ' is-sold-out'));
      article.appendChild(this.media(p, parts));
      var body = el('div', 'dh-card-body');
      if (parts.name) {
        var line = el('p', 'dh-card-category');
        // The first letter sits in .dh-card-initial, as on the Liquid cards; dh-symbols.js puts the symbol in front of it.
        var nameEl = el('span', 'dh-ux-cart-pick__name dh-recent-name');
        nameEl.appendChild(el('span', 'dh-card-initial', parts.name.charAt(0)));
        nameEl.appendChild(document.createTextNode(parts.name.slice(1)));
        line.appendChild(nameEl);
        body.appendChild(line);
      }
      var h3 = el('h3');
      var link = el('a', null, parts.desc);
      link.href = p.url;
      h3.appendChild(link);
      body.appendChild(h3);
      var price = this.price(p);
      var priceLine = el('p', 'dh-card-price');
      if (price.from) priceLine.appendChild(el('span', null, 'From'));
      priceLine.appendChild(document.createTextNode(price.text));
      body.appendChild(priceLine);
      article.appendChild(body);
      return article;
    }

    mini(p) {
      var parts = splitTitle(p.title);
      var li = el('li', 'dh-recent-mini' + (p.available ? '' : ' is-sold-out'));
      var link = el('a', 'dh-recent-mini__link');
      link.href = p.url;
      var media = el('span', 'dh-recent-mini__media');
      if (p.image) media.appendChild(picture(p, '132px', [180, 270, 360]));
      link.appendChild(media);
      if (parts.name) {
        var name = el('span', 'dh-recent-mini__name');
        name.appendChild(el('span', 'dh-ux-cart-pick__name dh-recent-name', parts.name));
        link.appendChild(name);
      }
      link.appendChild(el('span', 'dh-recent-mini__desc', parts.desc));
      var price = this.price(p);
      link.appendChild(el('span', 'dh-recent-mini__price', (price.from ? 'From ' : '') + price.text + (p.available ? '' : ' · Sold out')));
      li.appendChild(link);
      return li;
    }
  }

  customElements.define('dh-recent', DhRecent);
})();
